import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { shorthand368inlh8kflfb as shorthand } from '../../../iconShortcuts.mjs';
import { color1u2lxyvdop1o6 as color } from '../../work/payApps/data.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Constant5dc3leeorpdb as Constant } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../../../../theming/Titles.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { matchAlphaf1v7f410jfqp as matchAlpha } from '../../../../theming/appTheme.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function StateTagSemantic$default$lambda($this$to, it) {
  return $this$to.gd1(it, VOID, it.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().xg1_1));
}
var StateTagSemanticClass;
function StateTagSemantic() {
  if (StateTagSemanticClass === VOID) {
    class $ extends Semantic() {
      static ygt(state) {
        var $this = this.dd1('tag_' + shorthand(state.d90()));
        $this.xgt_1 = state;
        return $this;
      }
      ed1(theme) {
        var tmp2_background = color(this.xgt_1);
        var tmp0_vertical = get_rem(0.2);
        var tmp1_horizontal = get_rem(0.65);
        var tmp3_padding = Edges().ed0(tmp1_horizontal, tmp0_vertical);
        var tmp4_cornerRadii = new (Constant())(get_rem_0(1));
        var tmp = BodySemantic_getInstance();
        var tmp5_derivations = mapOf(to(tmp, StateTagSemantic$default$lambda));
        return this.jd1(theme, VOID, VOID, VOID, tmp4_cornerRadii, VOID, tmp3_padding, VOID, VOID, VOID, VOID, VOID, tmp2_background, VOID, VOID, VOID, VOID, VOID, tmp5_derivations);
      }
      toString() {
        return 'StateTagSemantic(state=' + toString(this.xgt_1) + ')';
      }
      hashCode() {
        return hashCode(this.xgt_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StateTagSemantic()))
          return false;
        if (!equals(this.xgt_1, other.xgt_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'StateTagSemantic');
    StateTagSemanticClass = $;
  }
  return StateTagSemanticClass;
}
function ClientConcernSelectButton$default$lambda($this$to, compact) {
  var tmp0_vertical = get_rem(0.3);
  var tmp1_horizontal = get_rem_0(1);
  var tmp = Edges().ed0(tmp1_horizontal, tmp0_vertical);
  var tmp_0 = BodySemantic_getInstance();
  return $this$to.gd1(compact, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp_0, ClientConcernSelectButton$default$lambda$lambda)));
}
function ClientConcernSelectButton$default$lambda$lambda($this$to, it) {
  return $this$to.gd1(it, VOID, it.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().xg1_1));
}
function ClientConcernSelectButton$default$lambda$lambda_0($this$to, it) {
  return $this$to.gd1(it, VOID, it.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().xg1_1));
}
var ClientConcernSelectButtonClass;
function ClientConcernSelectButton() {
  if (ClientConcernSelectButtonClass === VOID) {
    class $ extends Semantic() {
      static agw(state) {
        var $this = this.dd1('sel_' + shorthand(state.d90()));
        $this.zgv_1 = state;
        return $this;
      }
      ed1(theme) {
        var tmp0_$receiver = theme.fb1(ButtonSemantic_getInstance()).gb1_1;
        var tmp1_background = Companion_getInstance().taz_1;
        var tmp2_outlineWidth = get_AppDimensions().qg2_1;
        var tmp3_outline = matchAlpha(AppColors_getInstance().hfz_1.zg9_1, theme.lb0_1);
        var tmp = CompactSemantic_getInstance();
        var tmp_0 = to(tmp, ClientConcernSelectButton$default$lambda);
        var tmp_1 = SelectedSemantic_getInstance();
        var tmp4_derivations = mapOf_0([tmp_0, to(tmp_1, ($this$to, it) => {
          var tmp0_background = color(this.zgv_1);
          var tmp1_outlineWidth = get_rem_0(0);
          var tmp2_cornerRadii = new (Constant())(get_rem_0(1));
          var tmp = BodySemantic_getInstance();
          var tmp3_derivations = mapOf(to(tmp, ClientConcernSelectButton$default$lambda$lambda_0));
          return $this$to.jd1(it, VOID, VOID, VOID, tmp2_cornerRadii, VOID, VOID, VOID, VOID, VOID, tmp1_outlineWidth, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp3_derivations);
        })]);
        return this.jd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_outline, tmp2_outlineWidth, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'ClientConcernSelectButton(state=' + toString(this.zgv_1) + ')';
      }
      hashCode() {
        return hashCode(this.zgv_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConcernSelectButton()))
          return false;
        if (!equals(this.zgv_1, other.zgv_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConcernSelectButton');
    ClientConcernSelectButtonClass = $;
  }
  return ClientConcernSelectButtonClass;
}
//region block: exports
export {
  ClientConcernSelectButton as ClientConcernSelectButtonx5iavwcao070,
  StateTagSemantic as StateTagSemanticqbegmxb4xh2t,
};
//endregion

//# sourceMappingURL=tags.mjs.map
